import { Platform, Pressable, ScrollView, View } from 'react-native';
import { Text, Card, Avatar, ActivityIndicator } from 'react-native-paper';
import React, { useEffect, useState } from 'react';
import { useAppTheme } from '../theme';
import Fuse from 'fuse.js';
import { db } from '../Firebase/firebase';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { useAppSelector, useAppDispatch } from '../redux/hooks';
import { setBusinesses, setSelectedBusiness } from '../redux/businessListSlice';
import { Organization, Member, Business } from '../types';
import DetailsView from './details';
import Chip from '../components/chip';
import {
  setOrganization,
  useFetchOrganizationQuery,
} from '../redux/organizationSlice';
import { BottomSheetMethods } from '@gorhom/bottom-sheet/lib/typescript/types';
import MapView from 'react-native-maps';
interface Props {
  mapRef?: React.RefObject<MapView>;
  bottomSheetRef?: React.RefObject<BottomSheetMethods>;
  webMap?: google.maps.Map | null;
}

export default function BusinessList({
  mapRef,
  bottomSheetRef,
  webMap,
}: Props) {
  const theme = useAppTheme();
  const { filterOptions, businesses, businessSearchText, selectedBusiness } =
    useAppSelector((state) => state.businessList);

  const { mobileMapWindow } = useAppSelector((state) => state.map);
  const { user } = useAppSelector((state) => state.user);

  const dispatch = useAppDispatch();

  // const { data } = useFetchOrganizationQuery(fetchedUser!.id);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getOrg = async () => {
      if (user) {
        const organizationCollectionRef = collection(db, 'organizations');
        const organizationCollectionQuery = query(
          organizationCollectionRef,
          where('memberUids', 'array-contains-any', [user.id])
        );
        const organizationSnapshot = await getDocs(organizationCollectionQuery);
        const data = organizationSnapshot.docs.map((doc) => {
          return { ...(doc.data() as Organization), id: doc.id };
        });
        const memberCollectionRef = collection(
          db,
          `organizations/${data[0].id}/members`
        );
        const memberSnapShot = await getDocs(memberCollectionRef);
        const memberData = memberSnapShot.docs.map((doc) => {
          return doc.data() as Member;
        });
        const businessCollectionRef = collection(
          db,
          `organizations/${data[0].id}/businesses`
        );
        const businessSnapShot = await getDocs(businessCollectionRef);
        const businessData = businessSnapShot.docs.map((doc) => {
          return { ...(doc.data() as Business), id: doc.id };
        });
        const myOrganization: Organization = {
          id: data[0].id,
          name: data[0].name,
          createdAt: data[0].createdAt,
          memberUids: data[0].memberUids,
          members: memberData,
          businesses: businessData,
          imageName: data[0].imageName,
        };
        dispatch(setOrganization(myOrganization));
        dispatch(setBusinesses(myOrganization.businesses));
      }
    };
    setLoading(true);
    getOrg();
    setLoading(false);
  }, [user]);

  const filteredBusinesses = businesses.filter(
    (b) => filterOptions.length === 0 || filterOptions.includes(b.status)
  );

  const fuse = new Fuse(filteredBusinesses, {
    keys: ['name', 'address'],
    isCaseSensitive: false,
    includeScore: true,
    threshold: 0.4,
  });

  const searchResults =
    businessSearchText !== ''
      ? fuse.search(businessSearchText).map((s) => s.item)
      : filteredBusinesses;

  const loadSpinnerOrData = loading ? (
    <ActivityIndicator size={50} style={{ marginTop: 50 }} />
  ) : (
    searchResults.map((business) => {
      return (
        <Pressable key={business.id}>
          <Card
            mode="contained"
            style={{
              backgroundColor: theme.colors.background,
              padding: 3,
              borderWidth: 1,
              borderRadius: 6,
              marginVertical: 6,
              borderColor: theme.colors.backgroundBorder,
            }}
            onPress={() => {
              dispatch(setSelectedBusiness(business));

              if (Platform.OS !== 'web') {
                bottomSheetRef?.current?.snapToIndex(2);

                mapRef?.current?.animateToRegion(
                  {
                    latitude: business.latitude - 0.005,
                    longitude: business.longitude,
                    latitudeDelta: mobileMapWindow.latitudeDelta,
                    longitudeDelta: mobileMapWindow.longitudeDelta,
                  },
                  500
                );
              } else {
                webMap?.panTo({
                  lat: business.latitude,
                  lng: business.longitude,
                });
              }
            }}
          >
            <View
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                // padding: 4,
              }}
            >
              <Avatar.Icon
                icon="store"
                color={theme.colors.onBackground}
                style={{ backgroundColor: 'transparent' }}
              />
              <View
                style={{
                  position: 'absolute',
                  right: 0,
                  bottom: 0,
                }}
              >
                <Chip status={business.status}></Chip>
              </View>
              <View>
                <Text
                  style={{
                    color: theme.colors.onBackground,
                    fontWeight: 'bold',
                  }}
                >
                  {business.name}
                </Text>
                <Text
                  style={{
                    color: theme.colors.onBackground,
                    maxWidth: 200,
                  }}
                >
                  {business.address}
                </Text>
              </View>
            </View>
          </Card>
        </Pressable>
      );
    })
  );
  return (
    <ScrollView>
      {selectedBusiness ? <DetailsView webMap={webMap} /> : loadSpinnerOrData}
    </ScrollView>
  );
}
